import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const MOCK_TEST_URL = "https://fetc.in/api/v1/mock-tests";

export const mockTestApi = createApi({
  reducerPath: "mockTestApi",
  tagTypes: ["MockTests"],

  baseQuery: fetchBaseQuery({
    baseUrl: MOCK_TEST_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),

  endpoints: (builder) => ({
    /* ================= PUBLIC ================= */

    getMockTests: builder.query({
      query: () => "/",
      providesTags: ["MockTests"],
    }),

    getMockTestById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [
        { type: "MockTests", id },
      ],
    }),

    /* ================= ADMIN ================= */

    createMockTest: builder.mutation({
      query: (data) => ({
        url: "/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MockTests"],
    }),

    updateMockTest: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "MockTests", id },
      ],
    }),

    deleteMockTest: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MockTests"],
    }),
  }),
});

export const {
  useGetMockTestsQuery,
  useGetMockTestByIdQuery,
  useCreateMockTestMutation,
  useUpdateMockTestMutation,
  useDeleteMockTestMutation,
} = mockTestApi;